import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UsersType } from '../utilities/common-file';

@Component({
    templateUrl: './reports-list.component.html'
})
export class ReportsListComponent {
    showSettlements = false;
    loginUserType = '';

constructor(private authService: AuthService) {

}
// tslint:disable-next-line: use-lifecycle-interface
ngOnInit() {
    this.loginUserType = this.authService.getRole();
    this.showSettlements = this.authService.showOptionsBasedOnUserType();
}
getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    return this.authService.getModuleGroupAndModuleAccess(moduleName, groupName);
}
}
